export default __webpack_public_path__ + "static/media/Software_Source_Code.1462219c.png";